import state from './moduleCustomerGroupState'
import actions from './moduleCustomerGroupActions'
import getters from './moduleCustomerGroupGetters'
import mutations from './moduleCustomerGroupMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
